module.exports = __webpack_public_path__ + "media/images/flags/4x3/bhr-4da02938fecc891161e570d70e748051.svg";